import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconOrganizer = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#5F6567"} className={`organizer ${props.className}`} viewBox="3 3 18 18">
        <path d="M12,6 C13.1,6 14,6.9 14,8 C14,9.1 13.1,10 12,10 C10.9,10 10,9.1 10,8 C10,6.9 10.9,6 12,6 L12,6 Z M12,15 C14.7,15 17.8,16.29 18,17 L18,18 L6,18 L6,17.01 C6.2,16.29 9.3,15 12,15 L12,15 Z M12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 L12,4 Z M12,13 C9.33,13 4,14.34 4,17 L4,20 L20,20 L20,17 C20,14.34 14.67,13 12,13 L12,13 Z"></path>
    </IconWrapper>
);

export default memo(IconOrganizer);
